import { Anchor, type AnchorProps, type PolymorphicComponentProps } from "@mantine/core"
import Link from "next/link"
import type { ReactNode } from "react"

export type TAppLinkProps = PolymorphicComponentProps<typeof Link, AnchorProps & { href?: string | null }>

export function AppLink({ href, ...props }: TAppLinkProps) {
  if (!href) return props.children as ReactNode
  return <Anchor href={href} component={Link} fz="inherit" onClick={(e: any) => e.stopPropagation()} {...props} />
}
